<div class="flex flex-col gap-4">
    <p-tabs [value]="docKeys[0]">
        <p-tablist>
            @for (key of docKeys; track key) {
            <p-tab [value]="key">
                <span class="flex items-center gap-2">
                    {{ labels[key] }} @if (draft()[key].overridden) {
                    <p-tag severity="info" value="override" [rounded]="true" />
                    } @if (docDirty(key)) {
                    <p-tag severity="warn" value="edited" [rounded]="true" />
                    }
                </span>
            </p-tab>
            }
        </p-tablist>
        <p-tabpanels>
            @for (key of docKeys; track key) {
            <p-tabpanel [value]="key">
                <app-overridable-section
                    [title]="labels[key]"
                    [overridden]="draft()[key].overridden"
                    (overriddenChange)="onToggle(key, $event)"
                    [dirty]="docDirty(key)"
                    (reset)="resetDoc(key)"
                    [importable]="false"
                    widthClass="max-w-full lg:max-w-[50%]"
                >
                    <app-legal-doc-view
                        [doc]="draft()[key].doc"
                        [editable]="draft()[key].overridden"
                        (edit)="openEdit(key)"
                    />
                </app-overridable-section>
            </p-tabpanel>
            }
        </p-tabpanels>
    </p-tabs>
</div>

<app-legal-doc-edit-dialog
    [header]="editDialogHeader()"
    [(visible)]="editDialogVisible"
    [(title)]="editTitle"
    [(content)]="editContent"
    (apply)="applyEdit()"
/>
